import { Link, useTheme } from '@mui/material'
import { useNavState } from '../../navState/NavStateContext'
import { StringUtils } from '../../utils/StringUtils';
import { useEntityMgr } from '../../entityFramework/entityView/EntityMgrContext';
import { Mode } from '@/common/entityFramework/enumerations/Mode';

export const HyperlinkCellRenderer = ({ node, value, colDef }) => {

  const { navigateTo } = useNavState();
  const { hist, entityObj } = useEntityMgr();
  const theme = useTheme();

  const navigate = (openNewTab) => {
    const field = colDef.field;
    
    const idField = field.endsWith('Code') ? field.replace(/Code$/, 'Id') : 'id';
    const entityId = node.data[idField];
    
    const partition = field.endsWith('Code') ? node.data[field.replace(/Code$/, 'Partition')] : entityObj?.partition;
    
    const entity = colDef.entity ?? node.data.entity; // node.data.entity for cases where components hyperlink to foreign entities by entity and entityId (e.g. ValList)
    const route = colDef.module + '/' + StringUtils.toKebabConvention(entity);

    // Calculating As Of Date
    const now = new Date();
    const verStartInstant = new Date(node.data.verStartInstant);
    const verEndInstant = new Date(node.data.verEndInstant);

    const currentRecord = verStartInstant < now && now < verEndInstant;

    const asOfDate = hist && !currentRecord ? node.data.verEndInstant : null;

    const navState = {
      entityId: entityId,
      mode: Mode.DETAIL,
      asOfDate: asOfDate,
      partition: partition
    }
    
    navigateTo(route, navState, openNewTab);
  }

  return (
    <Link
      onClick={event => navigate(event.ctrlKey)}
      sx={{ 
        cursor: 'pointer',
        color: theme.palette.primary.dark
      }}
    >
      {value}
    </Link>
  )
}